import { ModelTypes } from "types";

/** No shared display collapse — fight and abusive stay separate chart entries. */
export function isSharedFeatureModel(_model?: string): boolean {
  return false;
}

/**
 * Pass-through. Fight and abusive keep distinct labels/entries.
 */
export function collapseSharedFeatureModels(models: ModelTypes[]): ModelTypes[] {
  return [...models];
}

export function countThreatsForDisplayModel(
  threats: { threatType?: { model?: string } }[] | undefined,
  displayModel: ModelTypes,
  _listedModels: ModelTypes[]
): number {
  if (!threats?.length) return 0;
  return threats.filter((threat) => threat.threatType?.model === displayModel).length;
}
